import axiosInst from '../../libs/axios/axios'
import i18n from '../../i18n/i18n.js'

const state = {
  rootUrl: process.env.VUE_APP_ROOT_URL
}
const getters = {}
const mutations = {}
const actions = {
  getWeatherData (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/apiary/${data.apiary_id}/weather_days/${data.days}/${i18n.locale}/`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
